import * as React from 'react';
import { Link } from 'react-router-dom';
import BulletedMsg from '../../../../layout/BulletedMsg';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { Str } from '../../../../localization/translationKeys';
import { css } from '@emotion/core';
import { COLORS } from '../../../../globalStyle/colors';


const styles = {
  root:       css`
    padding: 20px;
    border-radius: 8px;
    background-color: ${COLORS.LIGHTER_GREY};
    
    & > * {
      display: block;
      margin-bottom: 10px;
    }
    
    & > *:last-child {
      margin-bottom: 0;
    }
  `,
  option:     css`
    font-size: 12px;
    color: ${COLORS.DARK_GREY} !important;
    
    &:hover { 
      cursor: pointer;
      color: ${COLORS.BLUE} !important;
    }
  `,
  optionIcon: css`
    font-size: 20px;
  `,
  silentLink: css`
    text-decoration: none;
  `,
};


type Props = {
  className?: string;
  customerServiceUrl: string;
};


/**
 * CollaboratorAppActions: a component that  renders the list of actions in the side menu for the collaborator view
 * (currently customer service)
 */
const CollaboratorAppActions: React.FC<Props> = ({ className, customerServiceUrl }) => (
  <div css={styles.root} className={className}>
    <Link to={customerServiceUrl} css={styles.silentLink}>
      <BulletedMsg
        icon={faQuestionCircle}
        msg={Str.CustomerService}
        iconStyle={styles.optionIcon}
        css={styles.option}
      />
    </Link>
  </div>
);

export default CollaboratorAppActions;
